import { machineImageUrl } from '../../utils/imageProxy';
import { Card, Box, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import MachineStatus from './machineStatus';
import MachineType from './machineType';
import MachineCout from './machineCout';
import React from 'react';
import '../../css/machines/GridView.css';

const MachineListCardData = React.memo(({ index, style, data }) => {

    const { machines, columns, filteredMachinesCount } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredMachinesCount);

    return (
        <Box style={style} key={index}>
            <Grid container spacing={2}>
                {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                    const machineIndex = startIndex + idx;
                    const machine = machines[machineIndex];
                    const totalExpense = machine?.machine_expense?.reduce((sum, expense) => sum + expense.amount, 0);
                    const expencePercentOfPrice = Math.floor((totalExpense / machine?.purchase_price) * 100);

                    const imageUrl = machineImageUrl(machine, { size: 'small' });

                    return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={machine ? machine.id : `skeleton-${machineIndex}`}>
                            <Card className='machines_gridview_card'>
                                <CardActionArea onClick={machine ? () => navigate(`machine_details/${machine.id}`) : undefined}>
                                    {machine ? (
                                        <>
                                            {/* Blurred Background Image */}
                                            <CardMedia
                                                component="img"
                                                image={imageUrl || machineDefaultImage}
                                                alt={`${machine?.name} background`}
                                                style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    height: '192px',
                                                    top: 0,
                                                    left: 0,
                                                    zIndex: 0,
                                                    objectFit: 'cover',
                                                    filter: 'blur(10px)',
                                                }}
                                                loading="lazy"
                                                decoding="async"
                                            />

                                            {/* Main Image */}
                                            <CardMedia
                                                component="img"
                                                height="192"
                                                loading='lazy'
                                                decoding='async'
                                                image={imageUrl || machineDefaultImage}
                                                alt={machine.name}
                                                style={{
                                                    position: 'relative',
                                                    objectFit: imageUrl ? 'contain' : 'cover',
                                                    zIndex: 1
                                                }}
                                            />
                                            <CardContent className='machines_gridview_card_CardContent'>
                                                <Typography className='machines_gridview_machine_name' component="div">{machine?.name}</Typography>
                                                <Typography className='machines_gridview_machine_mark' component="div">{machine?.marque?.name ?? '--'}</Typography>
                                                <Typography className='machines_gridview_machine_mark' component="div">
                                                    {machine?.machine_metier?.length > 0 ? (
                                                        <>
                                                            <Box className='machines_gridview_machine_metier_Box'>
                                                                <Typography className='machines_gridview_machine_metier' component="span">{machine?.machine_metier[0]?.metier?.name}</Typography>
                                                                {machine?.machine_metier?.length > 1 && (
                                                                    <Typography className='machines_gridview_machine_metier_length' component="span">+{machine?.machine_metier?.length - 1}</Typography>
                                                                )}
                                                            </Box>
                                                        </>
                                                    ) : '--'}
                                                </Typography>
                                                <Box sx={{ width: '50%' }}>
                                                    <MachineCout expencePercentOfPrice={expencePercentOfPrice} />
                                                </Box>
                                                <Box className='machines_gridview_machine_footer_Box'>
                                                    <MachineStatus status={machine?.status} />
                                                    <MachineType type={machine?.type} />
                                                </Box>
                                            </CardContent>
                                        </>
                                    ) : (
                                        <>
                                            <Skeleton variant="rectangular" height={192} />
                                            <CardContent className='machines_gridview_card_CardContent'>
                                                <Skeleton variant="text" />
                                                <Skeleton variant="text" />
                                                <Skeleton variant="text" />
                                                <Box className='machines_gridview_machine_footer_Box'>
                                                    <Skeleton variant="text" />
                                                    <Skeleton variant="text" />
                                                </Box>
                                            </CardContent>
                                        </>
                                    )}
                                </CardActionArea>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
});

export default MachineListCardData;